<template>
  <div class="bonus">
    <BaseTitle
      size="l"
      is-medium
      class="bonus__title"
      text="А еще несколько приятных бонусов за участие в&nbsp;курсе&nbsp;:)"
    />
    <img
      src="@/assets/images/bonus.svg"
      alt="А еще несколько приятных бонусов за участие в курсе :)"
      class="bonus__image"
    >
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'TheBonusBanner',
  components: {
    BaseTitle,
  },
};
</script>

<style lang="stylus">
.bonus
  display block
  padding 1.5em
  margin 0
  background #50B2FF url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 682 150'%3E%3Cpath d='M0 60.027l28 5.999c29 5.998 86 12.996 142.5 7.997C227 69.025 322 14.541 379 5.044s96-4.498 134 5.998c54 12.497 84.562 62.981 169 62.981V150H0V60.027z' fill='%23AFDCFF'/%3E%3C/svg%3E") bottom center
  background-repeat no-repeat
  background-size 100% auto
  color #fff
  border-radius 1em
  overflow hidden
  +landscape()
    padding 3em
  &__title.title
    color inherit
    +landscape()
      max-width 70%
      font-size 2em
      padding-bottom 0
  &__image
    display block
    width 100%
    +landscape()
      width 70%
      margin-left auto
</style>
